/**
 *  This class returns the info about a user who has been successfully logged in
 */

import Result from './Result';
// import Photo from '../model/Photo';

class MutualLoginResult extends Result {
	private _mutualID: string;
	private _firstName: string;
	private _lastName: string;
	private _p_enabled: boolean;
	// private _photos: Photo[];

	/**
	 * @param success whether the request was successfully
	 * @param message contains the error if the request was unsuccessful
	 * @param mutualID the ID of the logged in user
	 * @param firstName the user's first name
	 * @param lastName the user's last name
	 * @param p_enabled whether the user is premium or not
	 * @param photos the photos on the user's profile
	 */
	constructor(
		success: boolean,
		message: string,
		mutualID: string,
		firstName: string,
		lastName: string,
		p_enabled: boolean,
		// photos: Photo[]
	) {
		super(success, message);
		this._mutualID = mutualID;
		this._firstName = firstName;
		this._lastName = lastName;
		this._p_enabled = p_enabled;
		// this._photos = photos;
	}

	get mutualID(): string {
		return this._mutualID;
	}

	set mutualID(value: string) {
		this._mutualID = value;
	}

	get firstName(): string {
		return this._firstName;
	}

	set firstName(value: string) {
		this._firstName = value;
	}

	get lastName(): string {
		return this._lastName;
	}

	set lastName(value: string) {
		this._lastName = value;
	}
	get p_enabled(): boolean {
		return this._p_enabled;
	}

	set p_enabled(value: boolean) {
		this._p_enabled = value;
	}
	// get photos(): Photo[] {
	// 	return this._photos;
	// }

	// set photos(value: Photo[]) {
	// 	this._photos = value;
	// }
}

export default MutualLoginResult;
